import { render } from "./Server.vue?vue&type=template&id=6787533e&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"

import "./Server.vue?vue&type=style&index=0&id=6787533e&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6787533e"]])

export default __exports__